// Open / close menu

var $ = jQuery;
$(function() {
	// Handler for .ready() called.
	const menu = $('#overlay');
	const content = $('#content');
	const body = $('body');

	const openMenu = $('.menu-icon, #menu-close, #mobile-menu, .close-icon');
	const openMenuMobile = $('#mobile-menu');
	const closeMenu = $('#menu-close');

	openMenu.on('click', function() {
		body.toggleClass('overlay-open');
		menu.toggleClass('hide');
	});

	console.log('WTF2');
	var acc = $('.dropdown-header');
	var i;

	for (i = 0; i < acc.length; i++) {
		acc[i].addEventListener('click', function() {
			this.classList.toggle('active');

			var panel = $('.sub-menu', this);
		});
	}

	// Show table of shortcuts in sidebar - Updated for Tailwind
	var openTableLink = $('.open_table, .shortcuts_table-close');
	var tables = $('.shortcuts_table');
	var i;

	for (i = 0; i < openTableLink.length; i++) {
		openTableLink[i].addEventListener('click', function() {
			$('.shortcuts_table').toggleClass('hidden');
			
			// Focus management for accessibility
			if (!$('.shortcuts_table').hasClass('hidden')) {
				// Focus the close button when opening
				setTimeout(function() {
					$('.shortcuts_table-close').focus();
				}, 100);
			}
		});
	}

	// ESC key support for closing table of contents
	$(document).on('keydown', function(e) {
		if (e.key === 'Escape' && !$('.shortcuts_table').hasClass('hidden')) {
			$('.shortcuts_table').addClass('hidden');
		}
	});

	// Close on backdrop click
	$(document).on('click', '.shortcuts_table', function(e) {
		if (e.target === this) {
			$(this).addClass('hidden');
		}
	});

	/*openMenuMobile.onclick = function() {
    menu.classList.toggle("hide");
    console.log("OK");
    content.classList.toggle("hide-content");
}

closeMenu.onclick = function() {
    menu.classList.toggle("hide");
    content.classList.toggle("hide-content");
}*/

	// Menu dropdown

	/*const magazine = document.getElementById("menu-item-759");
magazine.onclick = function(e) {
    e.preventDefault();
    setActiveMenu(magazine);
}

const directory = document.getElementById("menu-item-762");
directory.onclick = function(e) {
    e.preventDefault();
    setActiveMenu(directory);
}

const supplier = document.getElementById("menu-item-764");
supplier.onclick = function(e) {
    e.preventDefault();
    setActiveMenu(supplier);
}

const shop = document.getElementById("menu-item-766");
shop.onclick = function(e) {
    e.preventDefault();
    setActiveMenu(shop);
}*/

	function setActiveMenu(menu) {
		let subMenu = menu.getElementsByTagName('ul')[0];
		subMenu.classList.toggle('active');
	}
});
